<template>
  <div class="row">
    <div class="col-lg-12 col-xl-9 col-md-12 col-sm-12">
      <router-view :key="$route.fullPath"></router-view>
    </div>
    <!--导航-->
    <CvEditBar></CvEditBar>
  </div>
</template>

<script>
    import CvEditBar from "@/components/cv/CvEditBar";
    import {getBlockEnterpriseList, getMyCvView} from "@/api/cv";
    import {getAddrStrByAddrId, getAddrStrByAreaId} from "@/api/addr";
    import {getFileLink, getFileList} from "@/api/common";
    import {isEmpty} from "@/api/validator";
    import {getUserLabelList} from "@/api/job";

    export default {
        name: "cv_edit",
        components: {CvEditBar},
        computed:{
            currentUserType:{
                get: function () {
                    return this.$store.getters.userType
                }
            }
        },
        data() {
            return {
                baseInfo: {
                    id: "",
                    name: "",
                    sexDes: "",
                    marriageStateDes: "",
                    politicStateDes: "",
                    telephone: "",
                    email: "",
                    birthdaty: "",
                    livingAreaId: "",
                    highestEducationDes: "",
                    startEducationDes: "",
                    highestEducationTypeDes: "",
                    highestEducationStateDes: "",
                    startWorkTime: "",
                    hasWorkExpirence: "",
                    graduateState: true,
                    foreignExpirenceDes: "",
                    managementExpirenceDes: "",
                    jobAim: "",
                    intrest: "",
                    selfSummary: "",
                    addrStr: "",
                    industryStr:"",
                    jobTypeStr:"",
                    wechatNum:""
                },
                workRequired: {
                    id: "",
                    workState: "",
                    findWorkProperty: "",
                    hopeWorkCity: "",
                    hopeSalary: "",
                    hasDetailSalary: "",
                    testDuration: "",
                    testSalary: "",
                    testBenifit: "",
                    normalBenifit: "",
                    holidayRequired: "",
                    workTimeRequired: "",
                    businessTripRequeired: "",
                    hopeWorkStyle: "",
                    hopeProvide: "",
                    addrStr:""
                },
                workExpirenceList: [],
                educationExpirenceList: [],
                languageAbilityList: [],
                trainingExpirenceList: [],
                extskillList: [],
                cvFileIdList:[],
                certificateFileIdList:[],
                blockEnterpriseList:[],
                examList:[],
                jobApplyList:[],
                labelList:[]
            }
        },
        mounted() {
            const basicId = this.$route.query.basicId;
            if (basicId != null && basicId != '' && basicId != 'undefined') {
                this.getCvView();
                this.getFileLink();
            }
        },
        watch: {
            // 利用watch方法检测路由变化：
            '$route': function (to, from) {
                this.getCvView();
                this.getFileLink();
            }
        },
        methods: {
            getCvView() {
                //获取简历基本信息
                getMyCvView(this.$route.query.basicId).then(response => {
                    let bf = response.baseInfo;
                    if (bf != null) {
                        this.baseInfo = bf;
                        //地市编码转化为地址
                        if(bf.livingAreaId){
                            this.baseInfo.addrStr = getAddrStrByAreaId(bf.livingAreaId);
                        }
                    }
                    let wd = response.workRequired;
                    if (wd != null) {
                        this.workRequired = wd;
                        //地市编码转化为地址
                        if(wd.hopeWorkCity){
                            this.workRequired.addrStr = getAddrStrByAddrId(wd.hopeWorkCity);
                        }
                    }
                    let we = response.workExpirenceList;
                    if (we != null) {
                        this.workExpirenceList = we;
                    }
                    let ee = response.educationExpirenceList;
                    if (ee != null) {
                        this.educationExpirenceList = ee;
                    }
                    let la = response.languageAbilityList;
                    if (la != null) {
                        this.languageAbilityList = la;
                    }
                    let te = response.trainingExpirenceList;
                    if (te != null) {
                        this.trainingExpirenceList = te;
                    }
                    let es = response.extskillList;
                    if (es != null) {
                        this.extskillList = es;
                    }
                    //屏蔽企业
                    const blockEnterpriseLinkList=response.blockEnterpriseLinkList;
                    if(!isEmpty(blockEnterpriseLinkList)){
                        const entIds=[];
                        for (let b in blockEnterpriseLinkList){
                            entIds.push(blockEnterpriseLinkList[b].enterpriseId);
                        }
                        //获取屏蔽企业
                        getBlockEnterpriseList(entIds).then(response => {
                            this.blockEnterpriseList=response.blockEnterpriseList;
                        });
                    }
                    //获取标签类别
                    this.getLabelList();
                }).catch(error => {
                })
            },
            getFileLink(){
                const data={
                    moduleObjectId:this.$route.query.basicId
                };
                getFileLink(data).then(response => {
                    const linkList=response.links;
                    if(linkList!=null&&linkList.length>0){
                        let cvfileIdList=[];
                        let certificateFileIdList=[];
                        for(let link in linkList){
                            //附件
                            if(linkList[link].uploadType=='2'){
                                cvfileIdList.push(linkList[link].uploadId);
                            }
                            if(linkList[link].uploadType=='3'){
                                certificateFileIdList.push(linkList[link].uploadId);
                            }
                        }
                        if(cvfileIdList.length>0){
                            this.getCvFileList(cvfileIdList);
                        }
                        if(certificateFileIdList.length>0){
                            this.getCertificateFileList(certificateFileIdList);
                        }
                    }
                })
            },
            getCvFileList(fileIdList){
                //根据ID列表查询文件列表
                getFileList(fileIdList).then(response => {
                    this.cvFileIdList=response.fileList;
                })
            },
            getCertificateFileList(fileIdList){
                //根据ID列表查询文件列表
                getFileList(fileIdList).then(response => {
                    this.certificateFileIdList=response.fileList;
                })
            },
            downLoadFile(uploadId){
                if (!isEmpty(uploadId)) {
                    window.location.href='/api/dfs/file/downInnerFile?id='+uploadId
                }
            },
            getLabelList(){
                const userId = this.baseInfo.addUserId;
                getUserLabelList(userId).then(response => {
                    this.labelList=response.result;
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/cv/cv_edit.vue